import { seedToMnemonic } from '../crypto/bip39'

function hexToBytes(hex: string): Uint8Array {
    const out = new Uint8Array(hex.length / 2)
    for (let i = 0; i < out.length; i++) out[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16)
    return out
}

// Derive a human-readable device nickname from a sigKid: first two
// words of the BIP39 mnemonic seeded by the public-key bytes. Pure
// display helper — no crypto secrets, no network.
export function getDeviceNickname(sigKid: string): string {
    if (!sigKid || sigKid.length !== 64) return 'unknown'
    try {
        const sigKidBytes = hexToBytes(sigKid)
        const mnemonic = seedToMnemonic(sigKidBytes)
        return `${mnemonic[0]} ${mnemonic[1]}`
    } catch {
        return sigKid.substring(0, 8)
    }
}
